import { Action } from '@ngrx/store';
import { DeviceMgtListFilterActions, DeviceMgtListFilterActionTypes} from '../actions/device-mgt-list-filter.actions';


export interface State {
  RegionIdOption: number;
}

export const initialState: State = {
  RegionIdOption: -1
};

export function reducer(state = initialState, action: DeviceMgtListFilterActions): State {
  switch (action.type) {

    case DeviceMgtListFilterActionTypes.SelectedDeviceMgtListFilters:
        return {...state,
        RegionIdOption: action.payload.RegionId};
    default:
      return state;
  }
}
